import axios from "axios";

export default class Platform {
	constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getPlatformFiles() {
    try {
      const requests = [
        axios({
          method: "get",
          url: `${this.API_LINK}/bin/files/prod_platform`
        }),
        axios({
          method: "get",
          url: `${this.API_LINK}/bin/files/central_platform`
        })
      ]
      const response = await Promise.all(requests);
      return response.map(resp => resp.data);
    } catch (error) {
      throw error;
    }
  }

  async postPlatformFile(url, fileName) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/files/`,
        data: {
          fileName: fileName,
          source: url
        }
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }
}
